import { hosts } from 'settings';
import { selectMember } from 'logic/member';
import { selectProduct, getGraduationData } from 'logic/product';
import { createProgramReview } from 'logic/reviews';
import { confettiWidget } from 'utils';

export const ProgramGraduation = {
  template: `
    <section class="program-graduation">
      <program-nav></program-nav>
      <section class="py-3 py-md-5 mt-3 mt-md-0 overview">
        <div class="container">
          <div class="row">
            <div class="col-lg-6 mx-auto">
              <video-player-resumable
                video-id="$ctrl.program.productMeta.graduationVideo.brightcoveId || $ctrl.program.productMeta.introVideo.brightcoveId">
              </video-player-resumable>
            </div>
            <div class="col-lg-6 mx-auto">
              <h2 class="heading h1">
                <span ng-if="$ctrl.member.screenName">
                  {{ $ctrl.member.screenName }},
                </span>
                you have come so far in {{ $ctrl.program.weeks.length }} weeks!
              </h2>
              <p ng-bind="$ctrl.program.productMeta.graduationMessage"></p>
              <ul class="trophy-cabinet trophy-cabinet--bordered fa-ul ml-0">
                <li ng-repeat="item in $ctrl.graduationData.achievements track by $index">
                  <i class="fa-li fa fa-trophy"></i> {{ item }}
                </li>
              </ul>
            </div>
          </div>
        </div>
        <div id="confetti-widget"></div>
      </section>
      <section class="py-3 py-md-5 bg-gray-100">
        <div class="graduation-more-programs container text-center">
          <header>
            <h3 class="mb-0">Love {{ $ctrl.program.name }}?</h3>
            <p>Why not try something new:</p>
          </header>
          <div class="row justify-content-center">
            <div class="col-md-6 p-0 graduation-tile-divider">
              <div class="bg-img-voome-programs">
                <div class="graduation-more-tile bg-darken p-0">
                  <span class="logo logo-voome-programs"></span>
                  <div class="bg-white w-100 px-3 py-5">
                    <div class="row justify-content-center">
                      <p>
                        Short 4-week step-by-step programs led by an expert
                        trainer. Each program includes 3x 30 minute workouts per
                        week, and meal plans to complement your training. Access
                        forever, for only $39.95.
                      </p>
                    </div>
                    <a class="btn theme-btn theme-btn--inverse rounded w-100"
                      href="${hosts.public}/programs">
                      <span>View all Voome Programs ></span>
                    </a>
                  </div>
                </div>
              </div>
            </div>
            <div class="col-md-6 p-0">
              <div class="bg-img-voome">
                <div class="graduation-more-tile bg-darken p-0">
                  <span class="logo logo-voome-weekly"></span>
                  <div class="bg-white w-100 px-3 py-5">
                    <div class="row justify-content-center">
                      <p>
                        A workout and meal planning tool which gives you access
                        to over 1000 recipes and over 150 workouts to create
                        your own weekly health plan. 24/7 access for only $6.99
                        per week. Cancel anytime.
                      </p>
                    </div>
                    <a class="btn theme-btn theme-btn--inverse rounded w-100"
                      href="${hosts.public}">
                      <span>Find out more ></span>
                    </a>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </section>
      <button-full-width
        modal-target="#modalRestartProgram">
        <span>Loved {{ $ctrl.program.name }}? Restart Now!</span>
      </button-full-width>
      <div class="my-3 my-md-5 container">
        <div class="row">
          <div class="col-md-8 mb-5">
            <div class="graduation-certificate theme-program-graduation theme-border text-center">
              <div class="certificate-content px-3 px-md-4">
                <div class="d-flex justify-content-center mb-md-3">
                  <image-circle src="$ctrl.member.profile.avatarUrl.thumb">
                  </image-circle>
                </div>
                <h4 class="heading">
                  I just smashed the Voome Program
                </h4>
                <h2 class="theme-program-logo theme-program-logo--dark my-1 my-md-3 mx-3">
                  <span class="text-white">{{ $ctrl.program.name }}</span>
                </h2>
                <ul class="trophy-cabinet trophy-cabinet text-left fa-ul ml-0 mb-2">
                  <li ng-repeat="item in $ctrl.graduationData.achievements track by $index">
                    <i class="fa-li fa fa-trophy"></i> {{ item }}
                  </li>
                </ul>
              </div>
              <div class="certificate-logo navbar-brand">
                <nav-logo></nav-logo>
              </div>
            </div>
          </div>
          <div class="col-md-4 text-center">
            <div class="graduation-feedback">
              <div class="share-icon">
                <i class="fa fa-heart"></i> 1
              </div>
              <h4>
                Screenshot and share your success!
              </h4>
              <p class="mb-0">
                You've just smashed through a 4 Week Voome Program!! Screenshot
                and share this image to inspire your friends, using the hashtag.
                <b>{{ $ctrl.graduationData.hashtag }}</b>
              </p>
            </div>
            <div class="graduation-feedback">
              <div class="rate-us-stars d-flex justify-content-center align-items-center">
                <i class="fa fa-star" ng-repeat="n in [1,2,3,4,5] track by $index"></i>
              </div>
              <h4>
                How do you rate this program?
              </h4>
              <p>
                We think you're 5 stars.<br>
                How many stars would you give us?
              </p>
              <button-link data-toggle="modal" data-target="#modalFeedback">
                Rate us now
              </button-link>
              <modal target="modalFeedback">
                <modal-title>
                  <span ng-hide="$ctrl.hasReviewed">Give us feedback</span>
                  <span ng-show="$ctrl.hasReviewed">Thank you!</span>
                </modal-title>
                <modal-body>
                  <form-feedback
                    is-complete="$ctrl.hasReviewed"
                    on-submit="$ctrl.createProgramReview(
                      $ctrl.member.id,
                      $ctrl.voomeProductId,
                      data.description,
                      data.rating
                    )">
                  </form-feedback>
                </modal-body>
              </modal>
            </div>
          </div>
        </div>
      </div>
    </section>`,

  controller($ngRedux) {
    'ngInject';

    return {
      $onInit() {
        const connect = $ngRedux.connect(this.mapState, this.mapDispatch());
        this.unsubscribe = connect(this);
        confettiWidget().startAnimation();
      },

      $onDestroy() {
        this.unsubscribe();
        confettiWidget().cancelAnimation();
      },

      mapState({ member, product, reviews, router }) {
        const { voomeProductId } = router.currentParams;
        const { hasReviewed } = reviews;
        const program = selectProduct(product);

        return {
          program,
          hasReviewed,
          voomeProductId,
          graduationData: getGraduationData(program.name),
          member: selectMember(member),
        };
      },

      mapDispatch() {
        return {
          createProgramReview,
        };
      },
    };
  },
};



// WEBPACK FOOTER //
// ./src/containers/Program/Graduation.js